import DataGridTableSkeleton from "../../../../components/skeletons/DataGridTableSkeleton";

export default function ProductTypeListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
